module.exports = __webpack_public_path__ + "img/ico-entrada-s.d66d2663.png";